import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { CheckCircleIcon, DatabaseIcon, ClockIcon, CurrencyDollarIcon } from '../../assets/icons';
import { landingContent } from '../../config/content.config';
import Badge from '../Badge/Badge';
import Button from '../Button/Button';
import './Benefits.css';

const iconMap = {
  CheckCircleIcon: <CheckCircleIcon className="benefit-icon" />,
  DatabaseIcon: <DatabaseIcon className="benefit-icon" />,
  ClockIcon: <ClockIcon className="benefit-icon" />,
  CurrencyDollarIcon: <CurrencyDollarIcon className="benefit-icon" />
};

const Benefits = () => {
  const { benefits } = landingContent;
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation();
  const { ref: stepsRef, isVisible: stepsVisible } = useScrollAnimation();
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation();

  return (
    <section id="benefits" className="benefits">
      <div className="benefits-inner">
        <div 
          ref={headerRef}
          className={`benefits-header scroll-animate ${headerVisible ? 'is-visible' : ''}`}
        >
          <Badge>{benefits.header.label}</Badge>
          <h2 className="section-title">{benefits.header.title}</h2>
          <p className="benefits-description">
            {benefits.header.description}
          </p>
        </div>

        <div 
          ref={gridRef}
          className="benefits-grid"
        >
          {benefits.main.map((benefit, index) => (
            <div 
              key={index}
              className={`benefit-card-wrapper scroll-animate-container ${gridVisible ? 'is-visible' : ''}`}
              style={{ transitionDelay: `${index * 0.1}s` }}
            >
              <div className="card benefit-card">
                <div className="benefit-icon-wrapper">
                  {iconMap[benefit.icon]}
                </div>
                <h3 className="card-title">{benefit.title}</h3>
                <p className="card-description">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* How It Works */}
        <div 
          ref={stepsRef}
          className={`how-it-works scroll-animate ${stepsVisible ? 'is-visible' : ''}`}
        >
          <div className="how-it-works-header">
            <h3 className="how-it-works-title">{benefits.howItWorks.title}</h3>
            <p className="how-it-works-description">
              {benefits.howItWorks.description}
            </p>
          </div>
          <div className="steps">
            {benefits.howItWorks.steps.map((step, index) => (
              <div key={index} className="step">
                <div className="step-number">{step.number}</div>
                <h4 className="step-title">{step.title}</h4>
                <p className="step-description">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

         {/* CTA Section */}
         <div 
           ref={ctaRef}
           className={`benefits-cta scroll-animate ${ctaVisible ? 'is-visible' : ''}`}
         >
           <h3 className="benefits-cta-title">{benefits.cta.title}</h3>
           <p className="benefits-cta-description">
             {benefits.cta.description}
           </p>
           <Button 
             href={benefits.cta.href}
             external={true}
             className="benefits-cta-btn"
           >
             {benefits.cta.label}
           </Button>
         </div>
      </div>
    </section>
  );
};

export default Benefits;
